/** Rutas de autenticación/demo donde se oculta el shell autenticado. */
export const RUTAS_PUBLICAS_AUTH = [
  '/login',
  '/callback',
  '/registro',
  '/ui',
  '/terminos',
] as const;

/**
 * Rutas accesibles sin sesión activa.
 * Incluye documentos legales para cumplir URLs públicas exigidas por App Store / Play Store.
 */
export const RUTAS_ACCESO_SIN_SESION = [
  ...RUTAS_PUBLICAS_AUTH,
  '/terminos-de-uso',
  '/politica-de-privacidad',
] as const;

export function normalizarRuta(pathname: string): string {
  const s = (pathname ?? '').split('?')[0].replace(/\/+$/, '');
  return s || '/';
}

export function esRutaPublicaAuth(pathname: string): boolean {
  return (RUTAS_PUBLICAS_AUTH as readonly string[]).includes(normalizarRuta(pathname));
}

export function esRutaAccesoSinSesion(pathname: string): boolean {
  return (RUTAS_ACCESO_SIN_SESION as readonly string[]).includes(normalizarRuta(pathname));
}
